import { Number } from './global';

export default function prettyNumber(number) {
  return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}
const normalizeNonIntegers = num => (Number.isInteger(num) ? num : num.toFixed(2));
const normalize = Math.floor;

export function prettyThinNumber(number) {
  if (parseInt(number) > -1) {
    const isMillion = number / 1e6 >= 1;
    const isThousand = number / 1e3 >= 1;

    if (isMillion) {
      const milion = normalizeNonIntegers(number / 1e6);
      return `${milion.toString()}M`;
    }
    if (isThousand) {
      const thousand = normalizeNonIntegers(number / 1e3);
      return `${thousand.toString()}K`;
    }

    return number.toString();
  }
  return null;
}

export function toPercentage(top, bottom) {
  const topNum = parseInt(top);
  const bottomNum = parseInt(bottom);

  if (topNum > -1 && bottomNum > -1) {
    const percentage = normalize((topNum / bottomNum) * 100);
    if (percentage > -1) {
      return percentage.toString();
    }
  }

  return null;
}
